import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [

    {
        // Education Slide
        field: 'phqEducationSlide',
        type: 'info',
        educationalSlide:
          "Over the last 2 weeks, how often have you been bothered by any of the following problems?",
        label: '',
        answer: {}
    },

    {
        // 1
        label: 'Little interest or pleasure in doing things',
        field: 'phqPleasure',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 2
        label: 'Feeling down, depressed, or hopeless',
        field: 'phqHopeLess',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 3
        label: 'Trouble falling or staying asleep, or sleeping too much',
        field: 'phqTroubleFalling',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 4
        label: 'Feeling tired or having little energy',
        field: 'phqFeelingTired',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },
    
    {
        // 5
        label: 'Poor appetite or overeating',
        field: 'phqAppetite',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 6
        label: 'Feeling bad about yourself – or that you are a failure or have let yourself or your family down',
        field: 'phqFeelingBad',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 7
        label: 'Trouble concentrating on things, such as reading the newspaper orwatching television',
        field: 'phqTroubleConcentrating',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 8
        label: 'Moving or speaking so slowly that other people could have noticed?  Or the opposite – being so fidgety or restless that you have been moving around a lot more than usual',
        field: 'phqSpeakingSlowly',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 9
        label: 'Thoughts that you would be better off dead or of hurting yourself insome way',
        field: 'phqHurtingSelf',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 10
        label: 'Your evaluated score',
        field: 'phqEvaluated',
        type: 'evaluated',
        answer: answers => {
          let score = 0;
          Object.keys(answers).map(key => {
            const answer = answers[key];
            if (Object.keys(answer).length === 1) {
              score += parseInt(Object.keys(answer)[0], 10);
            }
          });
          return score;
        }
    },

    {
        //11
        label:
          'If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?',
        field: 'phqHowDifficult',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            {
              key: 'phqNotDifficult',
              value:
                'Not difficult at all'
            },
            {
              key: 'phqSomewhatDifficult',
              value:
                'Somewhat difficult'
            },
            {
              key: 'phqVeryDifficult',
              value: 'Very difficult'
            },
            {
              key: 'phqExtremelyDifficult',
              value:
                'Extremely difficult'
            }
          ]
        }
    }, 
];

export default questionsModels;
